<template>
  <div class="flex-row justify-content-end align-items-center">
    <p class="m-0">{{ formatDateTime }}</p>
  </div>
</template>

<script>
import DateFormatEnum from '~/enums/DateFormatEnum.js';
import moment from 'moment';

export default {
  name: "DateAndTimeCell.vue",
  props: {
    cellProps: {
      type: String,
      required: true
    },
  },
  computed:{
    formatDate(){
      return moment(this.cellProps).format(DateFormatEnum.DISPLAY_DATE);
    },
    formatTime(){
      return moment(this.cellProps).format(DateFormatEnum.DISPLAY_TIME);
    },
    formatDateTime(){
      return this.formatDate + ' ' + this.formatTime;
    },
  }
}
</script>
